<template>
    <figure>
        <img 
            src="@/assets/images/punto_red_logo_new_small.png" 
            alt="punto red logo">
    </figure>
</template>
<script>
    export default {
        name: "Banner"
    }
</script>
<style lang="scss" scoped>
    img {
        height: 40px;
    }
</style>

